export default __webpack_public_path__ + "295d42b191186986825913f885ea94c7.png";